<span class="reporting-help"
      type="button" cdkOverlayOrigin #helpIcon="cdkOverlayOrigin"
      (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <a href="{{content.link}}" target="_blank">
        <i class="far fa-question-circle"></i>
    </a>
</span>

<ng-template cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="helpIcon"
            [cdkConnectedOverlayOpen]="isOpen"
            [cdkConnectedOverlayPositions]="overlayPositions">
    <span class="help-tooltip" ng-show="showTooltip">
        <span [innerHTML]="content.title | translate"></span>
        <i class="fa-solid fa-caret-down"></i>
    </span>
</ng-template>

